/**
 * @file
 * @prettier
 */

import { formatCurrency } from "@/common/common.js";
import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeDLSecureBorrowerAutoDebitChangeAmountPage() {
  customValidationInit(false);
  aspControlValidationInit();

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.updateTotal = updateTotal;
}

function updateTotal(oInstall: string, oAdditional: string, oTotal: string, itemIndex: number) {
  // concatenate the itemIndex to the end of the element inputs
  oInstall = oInstall.concat("_" + itemIndex);
  oAdditional = oAdditional.concat("_" + itemIndex);
  oTotal = oTotal.concat("_" + itemIndex);

  // the install amount may come in with 2 values (separated by a comma) due to the responsive table
  // since these 2 values will be the same we can just get the 0th value all the time.
  var install = $("[id*='" + oInstall + "']")[0].innerText;
  install = install.substring(1);
  install = install.replace(",", "");
  let additional = String($("[id*='" + oAdditional + "']").val());

  // copy the textbox value into the hidden txt Additional
  var hdnTxtAdditionalId = "hdnTxtAdditional";
  hdnTxtAdditionalId = hdnTxtAdditionalId.concat("_" + itemIndex);
  $("[id*='" + hdnTxtAdditionalId + "']").val(additional);

  additional = additional.replace(",", "");
  var total = Number(install) + Number(additional);
  $("[id*='" + oTotal + "']").text("$" + formatCurrency(total));

  // copy the additional value into the current value field
  var lblTxtAdditionalId = "lblAdditionalAmount";
  lblTxtAdditionalId = lblTxtAdditionalId.concat("_" + itemIndex);
  $("[id*='" + lblTxtAdditionalId + "']").val(additional);
}
